import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 font-semibold text-12px xxl:text-14px" }, "Tier", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-3/12 font-semibold text-12px xxl:text-14px" }, " Dimulai Dari ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-3/12 font-semibold text-12px xxl:text-14px" }, "Sampai", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "w-4/12 font-semibold text-12px xxl:text-14px" }, " Biaya Tambahan ", -1)
const _hoisted_6 = { class: "w-1/12" }
const _hoisted_7 = { class: "py-5 pl-3" }
const _hoisted_8 = { class: "w-3/12" }
const _hoisted_9 = { class: "pr-4" }
const _hoisted_10 = { class: "w-3/12" }
const _hoisted_11 = { class: "pr-4" }
const _hoisted_12 = {
  key: 0,
  class: "pr-4"
}
const _hoisted_13 = {
  key: 1,
  class: "pr-4"
}
const _hoisted_14 = { class: "w-1/12 flex items-center px-3" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row justify-between text-12px xxl:text-14px my-5"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Tambah Tier ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: `flex flex-wrap flex-row ${_ctx.isCalculationTierValid ? 'relative' : ''} px-4 py-3 bg-gray-lp-1200`
      }, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ], 2),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tiers, (tier, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "flex flex-wrap flex-row border-b py-3"
        }, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(index + 1), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_LpInput, {
                modelValue: tier.tierStart,
                "onUpdate:modelValue": ($event: any) => (tier.tierStart = $event),
                format: _ctx.formatDecimal,
                suffix: "kg",
                error: _ctx.isErrorTierStartEnd(index) || _ctx.isErrorStartIntersection(index),
                isErrorIconCaption: false,
                errorCaption: _ctx.isErrorTierStartEnd(index) ? tier.tierStartError : 'Tier tidak boleh beririsan dengan tier lain',
                maxLength: tier.tierStartMaxLength
              }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "error", "errorCaption", "maxLength"])
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_LpInput, {
                modelValue: tier.tierEnd,
                "onUpdate:modelValue": ($event: any) => (tier.tierEnd = $event),
                format: _ctx.formatDecimal,
                suffix: "kg",
                error: _ctx.isErrorTierStartEnd(index) || _ctx.isErrorEndIntersection(index),
                isErrorIconCaption: false,
                errorCaption: tier.tierEndError,
                maxLength: tier.tierEndMaxLength
              }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "error", "errorCaption", "maxLength"])
            ])
          ]),
          _createVNode("div", {
            class: `${_ctx.tiers.length > 1 ? 'w-4/12' : 'w-5/12'}`
          }, [
            (_ctx.tipeBiaya ===  'percentage')
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode(_component_LpInput, {
                    modelValue: tier.tierAmount,
                    "onUpdate:modelValue": ($event: any) => (tier.tierAmount = $event),
                    format: _ctx.formatDecimal,
                    suffix: "%",
                    error: _ctx.isErrorTierAmount(index),
                    maxLength: tier.tierAmountMaxLength
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "error", "maxLength"])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode(_component_LpInput, {
                    modelValue: tier.tierAmount,
                    "onUpdate:modelValue": ($event: any) => (tier.tierAmount = $event),
                    format: _ctx.formatPrice,
                    prefix: "IDR"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "format"])
                ]))
          ], 2),
          _withDirectives(_createVNode("div", _hoisted_14, [
            _createVNode("div", {
              class: `self-center  w-12 ${_ctx.tierDisable ? 'text-gray-lp-500 ' : 'cursor-pointer text-red-lp-100'}`,
              onClick: ($event: any) => (_ctx.removeTier(index))
            }, [
              _createVNode(_component_Icons, {
                name: "icon-x",
                alt: "remove"
              })
            ], 10, ["onClick"])
          ], 512), [
            [_vShow, _ctx.tiers.length > 1]
          ])
        ]))
      }), 128))
    ]),
    (_ctx.tiers.length < 5)
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          _createVNode("div", {
            class: `flex gap-4  font-semibold pb-10 ${_ctx.tierDisable ? 'text-gray-lp-500' : 'cursor-pointer text-red-lp-100'}`,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTier && _ctx.addTier(...args)))
          }, [
            _createVNode(_component_Icons, {
              name: "plus-circle-outline",
              alt: "remove"
            }),
            _hoisted_16
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}